import {
    BrowserRouter,
    Routes,
    Route,
    Navigate
} from "react-router-dom";
import './App.css';
import ConnectView from "./ConnectView";
import ConvertLog from "./ConvertLog";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/connect" element={<ConnectView />} />
                <Route path="/convert" element={<ConvertLog />} />
                <Route path="/" element={<Navigate to="/connect" replace />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
